module.exports = __webpack_public_path__ + "static/media/ST.6672fb53.svg";